import React from "react";
import { Pagination } from "antd";
import "./PaginationTable.scss";

const PaginationTable = ({
  totalElements,
  onChange,
  page,
  size,
  isDisabled,
}) => {
  return (
    <div className="pagination-table">
      <Pagination
        current={page + 1}
        pageSize={size}
        total={totalElements || 0}
        // showTotal={(total, range) =>
        //   total > 0
        //     ? `${range[0]}-${range[1]} của ${total} phần tử`
        //     : `${range[1]}-${range[1]} của ${total} phần tử`
        // }
        // showSizeChanger
        // onShowSizeChange={onChange}
        onChange={onChange}
        disabled={isDisabled}
        // pageSizeOptions={['10', '20', '50']}
      />
      {/* <span className="info-page-size">{`${size} records/page`}</span> */}
    </div>
  );
};

export default PaginationTable;
